import { render, staticRenderFns } from "./mailjet.vue?vue&type=template&id=6c2c410c&scoped=true"
import script from "./mailjet.vue?vue&type=script&lang=js"
export * from "./mailjet.vue?vue&type=script&lang=js"
import style0 from "./mailjet.vue?vue&type=style&index=0&id=6c2c410c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c410c",
  null
  
)

export default component.exports